import { render, staticRenderFns } from "./ElButtonV2.vue?vue&type=template&id=60be6275"
import script from "./ElButtonV2.vue?vue&type=script&lang=js"
export * from "./ElButtonV2.vue?vue&type=script&lang=js"
import style0 from "./ElButtonV2.vue?vue&type=style&index=0&id=60be6275&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports